export { default as ContentfulProductQuartet } from './contentfulProductQuartet'
export { default as ProductQuartet } from './productQuartet'



// WEBPACK FOOTER //
// ./src/modules/contentful/productQuartet/index.js